import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';
import { useAccount } from '~/accountContext';
import { IdeaContent } from '~/content/types';
import { QUERY_IDEAS_COUNT } from './useIdeasCount';

const CREATE_IDEA = gql`
  mutation CreateIdea($input: IdeaCreationInput!) {
    ideaCreate(input: $input) {
      ... on IdeaMutationSuccess {
        success
        message
        idea {
          id
          content {
            text
          }
        }
      }
      ... on CoreWebAppCommonError {
        message
        code
        error
      }
    }
  }
`;

export function useCreateIdea() {
  // TODO: Disable this lint rule until we type the Account domain
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const accountContext = useAccount() as any;
  const account = accountContext?.account;
  const organizationId = account?.currentOrganization?.id;

  const [
    executeCreateIdea,
    {
      data: createIdeaData,
      loading: createIdeaLoading,
      error: createIdeaError,
    },
  ] = useMutation(CREATE_IDEA, {
    refetchQueries: [QUERY_IDEAS_COUNT],
  });

  const createIdea = useCallback(
    (content: IdeaContent, { isFromExtension = false }) => {
      if (organizationId) {
        executeCreateIdea({
          variables: {
            input: {
              content,
              organizationId,
              source: isFromExtension ? 'extension' : 'content',
            },
          },
        });
      }
    },
    [account]
  );

  return { createIdea, createIdeaData, createIdeaError, createIdeaLoading };
}
